const API_ROOT = 'https://sitebypro-server.ru/druzbamebel'

function getSavedUser() {
  try {
    return JSON.parse(localStorage.getItem('user')) || null
  } catch (e) {
    return null
  }
}

function normalizeUser(user) {
  if (!user) return null

  return {
    ...user,
    is_admin: Number(user.is_admin || 0)
  }
}

async function safeJson(response) {
  try {
    return await response.json()
  } catch (e) {
    return null
  }
}

export default {
  namespaced: true,

  state: () => ({
    user: normalizeUser(getSavedUser()),
    loading: false,
    error: '',
    bootstrapped: false
  }),

  getters: {
    user: (state) => state.user,
    loading: (state) => state.loading,
    error: (state) => state.error,
    bootstrapped: (state) => state.bootstrapped,
    isAuthenticated: (state) => Boolean(state.user && state.user.hash),
    isAdmin: (state) => Number(state.user?.is_admin || 0) === 1
  },

  mutations: {
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, value) {
      state.error = value
    },
    SET_BOOTSTRAPPED(state, value) {
      state.bootstrapped = value
    },
    SET_USER(state, user) {
      state.user = normalizeUser(user)

      if (state.user) {
        localStorage.setItem('user', JSON.stringify(state.user))
      } else {
        localStorage.removeItem('user')
      }
    }
  },

  actions: {
    async updateProfile({ commit, state }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', '')

      try {
        if (!state.user?.hash) {
          const message = 'Пользователь не авторизован'
          commit('SET_ERROR', message)
          return { ok: false, message }
        }

        const response = await fetch(`${API_ROOT}/user/update-profile-settings`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            hash: state.user.hash,
            FIO: payload.FIO || '',
            phone: payload.phone || '',
            vk: payload.vk || '',
            tg: payload.tg || ''
          })
        })

        const result = await safeJson(response)

        if (!result || String(result.status) !== '200') {
          const message = result?.data?.text || 'Не удалось обновить профиль'
          commit('SET_ERROR', message)
          return { ok: false, message }
        }

        const updatedUser = normalizeUser({
          ...state.user,
          ...result.data
        })

        commit('SET_USER', updatedUser)
        return { ok: true, user: updatedUser }
      } catch (error) {
        const message = 'Ошибка сети'
        commit('SET_ERROR', message)
        return { ok: false, message }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async bootstrap({ state, commit, dispatch }) {
      if (state.bootstrapped) {
        return true
      }

      if (!state.user?.email || !state.user?.hash) {
        commit('SET_BOOTSTRAPPED', true)
        return false
      }

      const result = await dispatch('relogin')
      commit('SET_BOOTSTRAPPED', true)
      return result.ok
    },

    async login({ commit, dispatch }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', '')

      try {
        const response = await fetch(`${API_ROOT}/user/get-user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: payload.email,
            password: payload.password
          })
        })

        const result = await safeJson(response)

        if (!result || String(result.status) !== '200') {
          const message = result?.data?.text || 'Не удалось войти'
          commit('SET_ERROR', message)
          return { ok: false, message }
        }

        const user = normalizeUser({
          ...result.data,
          email: payload.email
        })

        commit('SET_USER', user)
        dispatch('orders/clearOrdersCache', null, { root: true })
        return { ok: true, user }
      } catch (error) {
        const message = 'Ошибка сети'
        commit('SET_ERROR', message)
        return { ok: false, message }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async register({ commit }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', '')

      try {
        const response = await fetch(`${API_ROOT}/user/add-user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            FIO: payload.FIO,
            email: payload.email,
            password: payload.password,
            phone: payload.phone,
            vk: '',
            tg: ''
          })
        })

        const result = await safeJson(response)

        if (!result || String(result.status) !== '200') {
          const message = result?.data?.text || 'Не удалось зарегистрироваться'
          commit('SET_ERROR', message)
          return { ok: false, message }
        }

        return { ok: true, message: 'Регистрация прошла успешно' }
      } catch (error) {
        const message = 'Ошибка сети'
        commit('SET_ERROR', message)
        return { ok: false, message }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async relogin({ state, commit, dispatch }) {
      if (!state.user?.email || !state.user?.hash) {
        commit('SET_USER', null)
        return { ok: false }
      }

      try {
        const response = await fetch(`${API_ROOT}/user/relog-user`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: state.user.email,
            hash: state.user.hash
          })
        })

        const result = await safeJson(response)

        if (!result || String(result.status) !== '200') {
          commit('SET_USER', null)
          return { ok: false }
        }

        const user = normalizeUser({
          ...state.user,
          ...result.data
        })

        commit('SET_USER', user)
        dispatch('orders/clearOrdersCache', null, { root: true })
        return { ok: true, user }
      } catch (error) {
        commit('SET_USER', null)
        return { ok: false }
      }
    },

    logout({ commit, dispatch }) {
      commit('SET_USER', null)
      dispatch('orders/clearOrdersCache', null, { root: true })
      commit('SET_ERROR', '')
      return { ok: true }
    },

    clearError({ commit }) {
      commit('SET_ERROR', '')
    }
  }
}